import { AppModeState, name } from '../reducers/appMode';

interface AppState {
  [name]: AppModeState;
}

export const isAgentModeSelector = (state: AppState): boolean =>
  state[name].isAgentMode;
